const init = () => {
  const scrollToSecondBtn = document.getElementById('scroll-to-second');
  const header = document.querySelector('.js-header');
  const nav = document.querySelector('.js-sticky-nav');
  const firstSection = document.getElementById('home-hero');
  if (!firstSection) {
    return;
  }
  // Function for adding/removing a class when it comes into scope
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        header.classList.add('text-white', 'is-active');
        nav.classList.remove('text-black');
        nav.classList.add('text-current');
      } else {
        header.classList.remove('text-white', 'is-active');
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1, // Block visibility threshold (can be customized as you wish)
  });

  // Start tracking the visibility of the first block
  observer.observe(firstSection);
  if (scrollToSecondBtn) {
    scrollToSecondBtn.addEventListener('click', function () {
      const sections = document.querySelectorAll('section');
      if (sections.length > 1) {
        const secondSection = sections[1];
        secondSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
};

export default {
  init,
};
